import { render, staticRenderFns } from "./CreateProject.vue?vue&type=template&id=13ca1825&scoped=true&"
import script from "./CreateProject.vue?vue&type=script&lang=js&"
export * from "./CreateProject.vue?vue&type=script&lang=js&"
import style0 from "./CreateProject.vue?vue&type=style&index=0&id=13ca1825&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ca1825",
  null
  
)

component.options.__file = "CreateProject.vue"
export default component.exports